export const useGuestAlert = defineStore("guest_alert", () => {
  const open = ref(false);
  const title = ref("");
  const message = ref("");

  const close = () => {
    open.value = false;
  };

  const openModal = (modalTitle?: string, modalMessage?: string) => {
    open.value = true;
    if (modalMessage) message.value = modalMessage;
    if (modalTitle) title.value = modalTitle;
  };

  const setMessage = (modalMessage: string) => {
    message.value = modalMessage;
  };

  const setTitle = (modalTitle: string) => {
    title.value = modalTitle;
  };

  return { open, close, openModal, message, title, setMessage, setTitle };
});
